import {AfterViewInit, Component, OnChanges, SimpleChanges} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {GridPagamentoComponent} from '../grid-pagamento/grid-pagamento.component';
import {Pagamento} from '../objetos/Pagamento';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

interface CategoriaPagamentoComanda {
  tipo: string;
  label: string;
  descricao: string;
  icon: string;
  cor: string;
  formas: any[];
}

@Component({
  selector: 'app-pagamento-comanda-metodo',
  templateUrl: './pagamento-comanda-metodo.component.html',
  styleUrls: ['./pagamento-comanda-metodo.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class PagamentoComandaMetodoComponent extends GridPagamentoComponent implements OnChanges, AfterViewInit {
  categorias: CategoriaPagamentoComanda[] = [];
  categoriaSelecionada: CategoriaPagamentoComanda;
  tipoCategoriaSelecionada: string;
  pagamentoDivididoSelecionado: any;
  erroPagamentoControle = '';
  tipoErroPagamentoControle = '';
  chamarAtencaoOutraForma = false;

  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  categoriasBase: Array<Omit<CategoriaPagamentoComanda, 'formas'>> = [
    {
      tipo: 'dinheiro',
      label: 'Dinheiro',
      descricao: 'Pagamento em dinheiro',
      icon: 'fas fa-money-bill-wave',
      cor: 'verde'
    },
    {
      tipo: 'pix',
      label: 'Pix',
      descricao: 'Pix ou QR Code',
      icon: 'fas fa-qrcode',
      cor: 'turquesa'
    },
    {
      tipo: 'credito',
      label: 'Cartão de Crédito',
      descricao: 'Crédito',
      icon: 'fas fa-credit-card',
      cor: 'roxo'
    },
    {
      tipo: 'debito',
      label: 'Cartão de Débito',
      descricao: 'Débito',
      icon: 'fas fa-id-card',
      cor: 'azul'
    },
    {
      tipo: 'vale_refeicao',
      label: 'Vales',
      descricao: 'Refeição e alimentação',
      icon: 'fas fa-utensils',
      cor: 'laranja'
    },
    {
      tipo: 'voucher',
      label: 'Voucher / Vale',
      descricao: 'Voucher',
      icon: 'fas fa-ticket-alt',
      cor: 'vermelho'
    },
    {
      tipo: 'outros',
      label: 'Outros',
      descricao: 'Demais formas',
      icon: 'fas fa-ellipsis-h',
      cor: 'cinza'
    }
  ];

  ngAfterViewInit() {
    setTimeout(() => {
      this.atualizeCategorias();
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.formasDePagamento || changes.totalPagar || changes.pixOnlineTunaForma)
      setTimeout(() => {
        this.atualizeCategorias();
      }, 0);
  }

  obtenhaCategorias(): CategoriaPagamentoComanda[] {
    this.atualizeCategorias();
    return this.categorias;
  }

  selecioneCategoriaPorTipo(tipo: string, evento?: Event) {
    if(evento) {
      evento.preventDefault();
      evento.stopPropagation();
    }

    const categoria = this.categorias.find((item) => item.tipo === tipo);
    if(categoria)
      this.selecioneCategoria(categoria);
  }

  rastreieCategoria(indice: number, categoria: CategoriaPagamentoComanda) {
    return categoria.tipo;
  }

  private atualizeCategorias() {
    const formas = this.formasDePagamentoNaEntrega();
    const tiposCategorias = this.categoriasBase.map((categoria) => categoria.tipo);
    const formasClassificadas = formas.map((forma: any) => {
      const tipo = this.classifiqueForma(forma);

      return {
        forma,
        tipo: tiposCategorias.indexOf(tipo) >= 0 ? tipo : 'outros'
      };
    });

    this.categorias = this.categoriasBase
      .map((categoria) => {
        const formasCategoria = formasClassificadas
          .filter((item) => item.tipo === categoria.tipo)
          .map((item) => item.forma);

        if(categoria.tipo === 'pix' && this.pixOnlineTunaForma && !this.multiplasFormasPagamentos &&
          !formasCategoria.find((forma: any) => forma.id === this.pixOnlineTunaForma.id)) {
          formasCategoria.push(this.pixOnlineTunaForma);
        }

        return {
          ...categoria,
          formas: formasCategoria
        };
      })
      .filter((categoria) => categoria.formas.length);

    if(this.tipoCategoriaSelecionada)
      this.categoriaSelecionada = this.categorias.find((categoria) => categoria.tipo === this.tipoCategoriaSelecionada);
  }

  selecioneCategoria(categoria: CategoriaPagamentoComanda) {
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    this.categoriaSelecionada = categoria;
    this.tipoCategoriaSelecionada = categoria.tipo;
    this.msgErroAdicionar = '';
    this.limpeErroPagamentoControle();

    if(categoria.tipo === 'pix' && this.pixOnlineTunaForma && !this.multiplasFormasPagamentos &&
      !categoria.formas.length) {
      this.selecionouPixOnlineTuna();
      return;
    }

    if(this.exigeEscolhaForma(categoria)) {
      this.limpePagamentoParaEscolherForma(categoria);
      return;
    }

    if(categoria.formas.length === 1)
      this.selecioneFormaDaCategoria(categoria.formas[0]);
  }

  selecioneFormaDaCategoria(forma: any) {
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    this.limpeErroPagamentoControle();

    const tipoCategoria = this.classifiqueForma(forma);
    const categoriaDaForma = this.categorias.find((categoria) =>
      categoria.tipo === tipoCategoria);
    if(categoriaDaForma)
      this.categoriaSelecionada = categoriaDaForma;
    this.tipoCategoriaSelecionada = tipoCategoria;

    if(this.multiplasFormasPagamentos) {
      this.adicioneOuSelecionePagamentoDividido(forma);
      return;
    }

    if(this.ehPixOnlineTunaForma(forma)) {
      this.selecionePixOnlineTuna();
      return;
    }

    this.apliquePagamentoUnicoComanda(forma);
  }

  selecionePixOnlineTuna() {
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    this.limpeErroPagamentoControle();

    const categoriaPix = this.categorias.find((categoria) => categoria.tipo === 'pix');
    if(categoriaPix) this.categoriaSelecionada = categoriaPix;
    this.tipoCategoriaSelecionada = 'pix';

    this.selecionouPixOnlineTuna();
  }

  mudouMultiplasFormasComanda() {
    this.mudouMultiplasFormas();
    delete this.categoriaSelecionada;
    delete this.tipoCategoriaSelecionada;
    delete this.pagamentoDivididoSelecionado;
    this.limpeErroPagamentoControle();
  }

  podeAdicionarOutraFormaPagamento(): boolean {
    return !!(!this.multiplasFormasPagamentos &&
      !this.pagamentoBloqueadoPorPixOnline() &&
      !this.pixOnlineTunaSelecionado() &&
      this.formaDePagamentoEscolhida?.id &&
      this.pagamentosAtivos().length > 0 &&
      this.formasDePagamento.length > 1);
  }

  adicioneOutraFormaPagamento() {
    if(!this.podeAdicionarOutraFormaPagamento()) return;

    if(!this.obtenhaPagamentoUnico())
      this.apliquePagamentoUnicoComanda(this.formaDePagamentoEscolhida);

    this.multiplasFormasPagamentos = true;
    delete this.categoriaSelecionada;
    delete this.tipoCategoriaSelecionada;
    delete this.pagamentoDivididoSelecionado;
    this.deseslecioneFormaSemLimparCategoria();
    this.trocoPara = 0;
    this.troco = 0;
    this.mySelection = [];
    this.recalculePagamentosDivididos();
    this.limpeErroPagamentoControle();
    this.acioneAtencaoOutraForma();
    this.alterouOpcaoMultiplasFormas.emit();
    this.mudouFormaPagamento.emit();
  }

  removaPagamentoComanda(pagamento: any) {
    this.removaPagamento(pagamento);
    if(this.pagamentoDivididoSelecionado === pagamento)
      delete this.pagamentoDivididoSelecionado;

    this.recalculePagamentosDivididos();
    this.mudouFormaPagamento.emit();
  }

  adicionePagamentoDividido() {
    if(this.formaDePagamentoEscolhida && this.formaDePagamentoEscolhida.id)
      this.adicioneOuSelecionePagamentoDividido(this.formaDePagamentoEscolhida);

    this.mudouFormaPagamento.emit();
  }

  valorInformado(): number {
    const total = this.pagamentosAtivos().reduce((soma, pagamento: any) => {
      return soma + (Number(pagamento.valor) || 0);
    }, 0);

    return Number(total.toFixed(2));
  }

  valorInformadoSemTaxa(): number {
    const total = this.pagamentosAtivos().reduce((soma, pagamento: any) => {
      return soma + this.valorPagamentoSemTaxa(pagamento);
    }, 0);

    return Number(total.toFixed(2));
  }

  valorCoberturaInformada(): number {
    const total = this.pagamentosAtivos().reduce((soma, pagamento: any) => {
      return soma + this.valorCoberturaPagamento(pagamento);
    }, 0);

    return Number(total.toFixed(2));
  }

  totalTaxasPagamento(): number {
    const total = this.pagamentosAtivos().reduce((soma, pagamento: any) => {
      return soma + (Number(pagamento.taxa) || 0);
    }, 0);

    return Number(total.toFixed(2));
  }

  totalDescontosPagamento(): number {
    const total = this.pagamentosAtivos().reduce((soma, pagamento: any) => {
      return soma + this.valorDescontoPagamento(pagamento);
    }, 0);

    return Number(total.toFixed(2));
  }

  formaTemTaxa(forma: any): boolean {
    const taxa = forma?.taxaCobranca;
    if(!taxa || taxa.ativa === false) return false;

    return Number(taxa.percentual || 0) > 0 || Number(taxa.valor || 0) > 0;
  }

  obtenhaDescricaoTaxaForma(forma: any): string {
    const taxa = forma?.taxaCobranca;
    if(!taxa) return '';

    if(Number(taxa.percentual || 0) > 0)
      return '+' + this.formatePercentualForma(taxa.percentual) + '% taxa';

    return '+' + this.formateValorPagamento(taxa.valor) + ' taxa';
  }

  formaTemDesconto(forma: any): boolean {
    if(forma?.possuiDesconto === false) return false;

    return Number(forma?.desconto || 0) > 0;
  }

  obtenhaDescricaoDescontoForma(forma: any): string {
    return 'desconto -' + this.formatePercentualForma(forma?.desconto) + '%';
  }

  private formatePercentualForma(valor: any): string {
    const percentual = Number(valor || 0);
    if(Number.isInteger(percentual)) return String(percentual);

    return percentual.toFixed(2).replace('.', ',');
  }

  diferencaPagamento(): number {
    return Number((this.totalPagar - this.valorCoberturaInformada()).toFixed(2));
  }

  valorExcedente(): number {
    const diferenca = this.diferencaPagamento();

    return diferenca < 0 ? Math.abs(diferenca) : 0;
  }

  selecionouPagamentoDividido(pagamento: any) {
    if(this.pagamentoBloqueadoPorPixOnline()) return;

    this.pagamentoDivididoSelecionado = pagamento;
    this.formaDePagamentoEscolhida = pagamento.formaDePagamento;
    this.tipoCategoriaSelecionada = this.classifiqueForma(pagamento.formaDePagamento);
    this.categoriaSelecionada = this.categorias.find((categoria) =>
      categoria.tipo === this.tipoCategoriaSelecionada);
  }

  alterouValorPagamentoDividido(pagamento: any, valor: number) {
    pagamento.valorInformado = Number(valor || 0);
    this.recalculePagamentosDivididos();
    this.mudouFormaPagamento.emit();
  }

  pagamentoDivididoEstaSelecionado(pagamento: any): boolean {
    return this.pagamentoDivididoSelecionado === pagamento;
  }

  pagamentoEhDinheiro(pagamento: any): boolean {
    return pagamento && this.classifiqueForma(pagamento.formaDePagamento) === 'dinheiro';
  }

  valorMinimoDinheiro(): number {
    const pagamento = this.obtenhaPagamentoUnico();
    const valor = pagamento && pagamento.formaDePagamento ? pagamento.valor : this.totalPagar;

    return Number(Number(valor || 0).toFixed(2));
  }

  pagamentoSemTrocoExcedeuTotal(pagamento: any): boolean {
    if(!pagamento || pagamento.removido || this.pagamentoEhDinheiro(pagamento)) return false;

    return this.coberturaPorValorInformado(pagamento.formaDePagamento, this.valorDigitadoPagamento(pagamento)) >
      Number(this.totalPagar || 0) + 0.009;
  }

  obtenhaErroPagamentoSemTrocoExcedenteTotal(): string {
    return 'Valor maior que o total da comanda. Máximo: ' +
      this.formateValorPagamento(this.totalPagar);
  }

  categoriaEstaSelecionada(categoria: CategoriaPagamentoComanda): boolean {
    const tipoSelecionado = this.tipoCategoriaSelecionada ||
      (this.formaDePagamentoEscolhida?.id ? this.classifiqueForma(this.formaDePagamentoEscolhida) : null);

    return tipoSelecionado === categoria.tipo;
  }

  formaEstaSelecionada(forma: any): boolean {
    return this.formaDePagamentoEscolhida && this.formaDePagamentoEscolhida.id === forma.id;
  }

  pagarEmDinheiro() {
    return this.formaDePagamentoEscolhida && this.classifiqueForma(this.formaDePagamentoEscolhida) === 'dinheiro';
  }

  categoriaAtualEhDinheiro(): boolean {
    return this.tipoCategoriaAtual() === 'dinheiro';
  }

  categoriaAtualEhPix(): boolean {
    return this.tipoCategoriaAtual() === 'pix';
  }

  exibeEscolhaForma(): boolean {
    return !!(this.categoriaSelecionada && this.categoriaSelecionada.formas.length &&
      this.exigeEscolhaForma(this.categoriaSelecionada));
  }

  exibeFormasCategoriaHorizontal(): boolean {
    return !!(this.categoriaSelecionada && this.categoriaSelecionada.formas &&
      this.categoriaSelecionada.formas.length);
  }

  obtenhaGridTemplateFormasCategoria(): string {
    if(!this.categoriaSelecionada || !this.categoriaSelecionada.formas || !this.categoriaSelecionada.formas.length)
      return null;

    const colunas = Math.min(this.categoriaSelecionada.formas.length, 4);

    return `repeat(${colunas}, minmax(0, 1fr))`;
  }

  tituloEscolhaForma(): string {
    if(this.categoriaAtualEhPix()) return 'Escolha o Pix';

    if(this.categoriaSelecionada && (this.categoriaSelecionada.tipo === 'credito' ||
      this.categoriaSelecionada.tipo === 'debito' || this.categoriaSelecionada.tipo === 'vale_refeicao' ||
      this.categoriaSelecionada.tipo === 'voucher')) {
      return 'Escolha sua bandeira';
    }

    return 'Escolha a forma';
  }

  tituloDetalhePagamento(): string {
    if(!this.categoriaSelecionada) return '';

    if(this.categoriaAtualEhDinheiro()) return 'Pagamento em Dinheiro';
    if(this.categoriaAtualEhPix()) return 'Pagamento via Pix';

    return `Pagamento em ${this.categoriaSelecionada.label}`;
  }

  descricaoDetalhePagamento(): string {
    if(this.categoriaAtualEhDinheiro()) return 'Informe o valor recebido e calcularemos o troco.';
    if(this.categoriaAtualEhPix()) return this.obtenhaMensagemEscolhaForma();

    return 'Confirme a forma selecionada para registrar o pagamento.';
  }

  obtenhaIconeForma(forma: any): string {
    const categoria = this.classifiqueForma(forma);
    const config = this.categoriasBase.find((item) => item.tipo === categoria);

    return config ? config.icon : 'fas fa-wallet';
  }

  obtenhaNomeBandeira(forma: any): string {
    if(this.ehPixOnlineTunaForma(forma))
      return 'Pix QRCode';

    if(forma?.bandeira?.nome && forma?.bandeira?.nome !== 'Pix')
      return forma.bandeira.nome;

    return String(forma?.descricao || '').replace(/^.*\s-\s/, '') || 'Bandeira';
  }

  obtenhaDescricaoOpcaoPix(forma: any): string {
    if(this.ehPixOnlineTunaForma(forma))
      return 'Gera um QR Code para o cliente pagar.';

    return 'Gera o QR Code no sistema da maquininha.';
  }

  obtenhaImagemBandeira(forma: any): string {
    if(this.ehPixOnlineTunaForma(forma))
      return '';

    return forma?.bandeira?.imagem || forma?.bandeira?.imagemUrl || '';
  }

  ehImagemSvgBandeira(forma: any): boolean {
    return this.obtenhaImagemBandeira(forma).indexOf('<svg') >= 0;
  }

  obtenhaSvgBandeira(forma: any): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.obtenhaImagemBandeira(forma));
  }

  obtenhaClasseCor(categoria: CategoriaPagamentoComanda): string {
    return `metodo-${categoria.cor}`;
  }

  obtenhaMensagemEscolhaForma(categoria: CategoriaPagamentoComanda = this.categoriaSelecionada): string {
    if(!categoria) return 'Selecione uma forma de pagamento para concluir.';

    if(categoria.tipo === 'pix') return 'Selecione uma opção Pix para concluir o pagamento.';

    if(categoria.tipo === 'credito' || categoria.tipo === 'debito' ||
      categoria.tipo === 'vale_refeicao' || categoria.tipo === 'voucher') {
      return `Selecione uma bandeira de ${categoria.label} para concluir o pagamento.`;
    }

    return `Selecione uma opção de ${categoria.label} para concluir o pagamento.`;
  }

  obtenhaMensagemEscolhaCategoria(): string {
    return this.multiplasFormasPagamentos ?
      'Selecione uma forma de pagamento para adicionar.' :
      'Selecione uma forma de pagamento para concluir.';
  }

  exibeErroCategoriaPagamento(): boolean {
    return this.tipoErroPagamentoControle === 'categoria';
  }

  exibeErroEscolhaForma(): boolean {
    return this.tipoErroPagamentoControle === 'forma' && this.exibeEscolhaForma();
  }

  exibeErroPixOnline(): boolean {
    return this.tipoErroPagamentoControle === 'pix-online' && this.pixOnlineTunaSelecionado();
  }

  obtenhaErroPagamento() {
    this.limpeErroPagamentoControle();

    const erroControle = this.obtenhaErroPagamentoControle();
    if(erroControle)
      return erroControle;

    if(this.multiplasFormasPagamentos) {
      const erroPagamentoDividido = this.obtenhaErroPagamentoDivididoEspecifico();
      if(erroPagamentoDividido)
        return erroPagamentoDividido;

      return this.obtenhaErroSomaPagamentoDividido();
    }

    const erroGenerico = super.obtenhaErroPagamento();
    if(erroGenerico)
      return erroGenerico;

    return null;
  }

  private obtenhaErroPagamentoDivididoEspecifico() {
    const pagamentosAtivos = this.pagamentosAtivos();
    if(!pagamentosAtivos.length)
      return 'Adicione uma forma de pagamento';

    const pagamentoInvalido = pagamentosAtivos.find((pagamento: any) => !this.pagamentoDivididoTemValorValido(pagamento));
    if(pagamentoInvalido)
      return `Valor do pagamento em ${pagamentoInvalido.formaDePagamento.descricao} está inválido`;

    const pagamentoSemTrocoExcedente = pagamentosAtivos.find((pagamento: any) =>
      this.pagamentoSemTrocoExcedeuTotal(pagamento));
    if(pagamentoSemTrocoExcedente)
      return this.obtenhaErroPagamentoSemTrocoExcedenteTotal();

    return null;
  }

  private obtenhaErroSomaPagamentoDividido() {
    const diferenca = this.diferencaPagamento();

    if(diferenca < 0)
      return 'A soma dos pagamentos não pode passar do total da comanda';

    if(diferenca > 0)
      return 'Ainda está faltando adicionar ' + this.formateValorPagamento(diferenca) + ' no pagamento';

    return null;
  }

  private formateValorPagamento(valor: number): string {
    return Number(valor || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  setPagamentos(pagamentos: Array<Pagamento>) {
    super.setPagamentos(pagamentos);
    this.recalculePagamentosDivididos();
  }

  private deseslecioneFormaSemLimparCategoria() {
    delete this.pagamentoEmEdicao;
    this.formaDePagamentoEscolhida = {
      id: null,
      descricao: '',
      valor: 0,
      trocoPara: 0
    };
  }

  private limpePagamentoParaEscolherForma(categoria: CategoriaPagamentoComanda) {
    if(this.formaDePagamentoEscolhida?.id &&
      this.classifiqueForma(this.formaDePagamentoEscolhida) === categoria.tipo) {
      return;
    }

    this.deseslecioneFormaSemLimparCategoria();
    this.trocoPara = 0;
    this.troco = 0;
    this.mySelection = [];

    if(this.multiplasFormasPagamentos) {
      this.mudouFormaPagamento.emit();
      return;
    }

    this.pagamentos = this.pagamentos.filter((pagamento: any) => {
      if(pagamento.id) {
        this.removaPagamento(pagamento);
        return true;
      }

      return false;
    });
    this.mudouFormaPagamento.emit();
  }

  private adicioneOuSelecionePagamentoDividido(forma: any) {
    let pagamento = this.obtenhaPagamentoSelecionado(forma);

    if(!pagamento) {
      pagamento = new Pagamento();
      pagamento.formaDePagamento = forma;
      pagamento.valorInformado = this.obtenhaValorRestanteParaForma(forma);
      this.pagamentos.push(pagamento);
    } else {
      delete pagamento.removido;
      if(this.valorInformadoEstaVazio(pagamento.valorInformado))
        pagamento.valorInformado = pagamento.trocoPara || pagamento.valor || this.obtenhaValorRestanteParaForma(forma);
    }

    this.formaDePagamentoEscolhida = forma;
    this.tipoCategoriaSelecionada = this.classifiqueForma(forma);
    this.pagamentoDivididoSelecionado = pagamento;
    this.recalculePagamentosDivididos();
    this.msgErroAdicionar = '';
    this.limpeErroPagamentoControle();
    this.mudouFormaPagamento.emit();
  }

  private pagamentosAtivos(): any[] {
    return (this.pagamentos || []).filter((pagamento: any) => !pagamento.removido);
  }

  novoValorPagar(novoTotal: number) {
    if(this.totalPagar === novoTotal) return;

    this.totalPagar = novoTotal;

    if(this.multiplasFormasPagamentos) {
      this.limpePagamentos();
      return;
    }

    const pagamento = this.obtenhaPagamentoUnico();
    if(!pagamento || !pagamento.formaDePagamento) return;

    pagamento.valor = this.totalPagar;
    pagamento.taxa = 0;
    pagamento.desconto = 0;
    pagamento.trocoPara = 0;

    this.apliqueDescontoFormaPagamento(pagamento);

    if(pagamento.formaDePagamento.taxaCobranca && typeof pagamento.setValorComTaxa === 'function')
      pagamento.setValorComTaxa(pagamento.formaDePagamento.taxaCobranca);

    if(this.pagamentoEhDinheiro(pagamento)) {
      this.trocoPara = pagamento.valor;
      pagamento.trocoPara = pagamento.valor;
      this.calculeTroco();
    }
  }

  obtenhaValorRestanteAhPagar(pagamentoEditando: any = null) {
    let valor = this.totalPagar;
    let totalPago = 0.0;

    for(let pagamento of this.pagamentosNaOrdemDeCalculo()) {
      if(pagamento.removido) continue;
      if(pagamentoEditando && (pagamento === pagamentoEditando ||
        (pagamentoEditando.id && pagamento.id === pagamentoEditando.id))) continue;

      totalPago += this.valorCoberturaPagamento(pagamento);
    }

    valor -= totalPago;

    if(valor < 0)
      valor = 0;

    return Number(valor.toFixed(2));
  }

  private obtenhaValorRestanteParaForma(forma: any, pagamentoEditando: any = null): number {
    const valorRestante = this.obtenhaValorRestanteAhPagar(pagamentoEditando);

    return this.valorInformadoParaCobertura(forma, valorRestante);
  }

  valorRestantePagamento(pagamento: any): number {
    if(!pagamento || pagamento.removido) return 0;

    return this.obtenhaValorRestanteParaForma(pagamento.formaDePagamento, pagamento);
  }

  exibeBotaoUsarValorRestante(): boolean {
    return this.pagamentosAtivos().length > 1;
  }

  useValorRestantePagamento(pagamento: any, evento?: Event) {
    if(evento) {
      evento.preventDefault();
      evento.stopPropagation();
    }

    if(!pagamento || pagamento.removido) return;

    pagamento.valorInformado = this.valorRestantePagamento(pagamento);
    this.recalculePagamentosDivididos();
    this.mudouFormaPagamento.emit();
  }

  private apliquePagamentoUnicoComanda(forma: any) {
    const pagamento = this.obtenhaOuCriePagamentoUnicoComanda();

    this.formaDePagamentoEscolhida = forma;
    this.mySelection = forma?.id ? [forma.id] : [];
    this.temTroco = 'nao';
    this.trocoPara = 0;
    this.troco = 0;

    delete pagamento.removido;
    pagamento.valor = this.totalPagar;
    pagamento.taxa = 0;
    pagamento.desconto = 0;
    pagamento.trocoPara = 0;
    pagamento.formaDePagamento = forma;

    this.apliqueDescontoFormaPagamento(pagamento);

    if(forma?.taxaCobranca && typeof pagamento.setValorComTaxa === 'function')
      pagamento.setValorComTaxa(forma.taxaCobranca);

    if(this.pagarEmDinheiro()) {
      this.trocoPara = pagamento.valor;
      pagamento.trocoPara = pagamento.valor;
      this.calculeTroco();
    }

    this.msgErroAdicionar = '';
    this.limpeErroPagamentoControle();
    this.mudouFormaPagamento.emit();
  }

  private acioneAtencaoOutraForma() {
    this.chamarAtencaoOutraForma = false;

    setTimeout(() => {
      this.chamarAtencaoOutraForma = true;

      setTimeout(() => {
        this.chamarAtencaoOutraForma = false;
      }, 700);
    }, 0);
  }

  private obtenhaOuCriePagamentoUnicoComanda(): any {
    let pagamento = this.obtenhaPagamentoUnico();

    if(!pagamento) {
      pagamento = new Pagamento();
      this.pagamentos.push(pagamento);
      return pagamento;
    }

    this.pagamentos.forEach((item: any) => {
      if(item === pagamento) return;

      if(item.id) {
        item.removido = true;
        item.valorRemovido = item.valor;
        item.valor = 0;
        item.trocoPara = 0;
        item.desconto = 0;
      }
    });

    this.pagamentos = this.pagamentos.filter((item: any) => item === pagamento || item.id);

    return pagamento;
  }

  private apliqueValorPagamentoDividido(pagamento: any) {
    const valorInformado = Number(pagamento.valorInformado || 0);
    const valoresPagamento = this.calculeValoresPagamentoPorValorInformado(pagamento.formaDePagamento, valorInformado);

    pagamento.trocoPara = 0;
    pagamento.taxa = valoresPagamento.taxa;
    pagamento.desconto = valoresPagamento.desconto;
    pagamento.valor = valoresPagamento.valor;
  }

  private recalculePagamentosDivididos() {
    const pagamentosAtivos = this.pagamentosNaOrdemDeCalculo();

    pagamentosAtivos.forEach((pagamento: any) => {
      if(this.valorInformadoEstaVazio(pagamento.valorInformado))
        pagamento.valorInformado = pagamento.trocoPara || pagamento.valor;
    });

    pagamentosAtivos.forEach((pagamento: any) => {
      this.apliqueValorPagamentoDividido(pagamento);
    });
  }

  private pagamentosNaOrdemDeCalculo(): any[] {
    return this.pagamentosAtivos()
      .map((pagamento: any, indice: number) => ({ pagamento, indice }))
      .sort((a: any, b: any) => {
        const aTemDesconto = this.formaTemDesconto(a.pagamento.formaDePagamento);
        const bTemDesconto = this.formaTemDesconto(b.pagamento.formaDePagamento);

        if(aTemDesconto !== bTemDesconto)
          return aTemDesconto ? -1 : 1;

        return a.indice - b.indice;
      })
      .map((item: any) => item.pagamento);
  }

  private valorPagamentoSemTaxa(pagamento: any): number {
    const valor = Number(pagamento.valor || 0) - Number(pagamento.taxa || 0);

    return Number(valor.toFixed(2));
  }

  private valorDescontoPagamento(pagamento: any): number {
    const desconto = Number(pagamento?.desconto || 0);

    return Number(desconto.toFixed(2));
  }

  private valorCoberturaPagamento(pagamento: any): number {
    const valor = this.valorPagamentoSemTaxa(pagamento) + this.valorDescontoPagamento(pagamento);

    return Number(valor.toFixed(2));
  }

  private pagamentoDivididoTemValorValido(pagamento: any): boolean {
    return Number(pagamento?.valor || 0) > 0 && this.valorCoberturaPagamento(pagamento) > 0;
  }

  private calculeValoresPagamentoPorValorInformado(formaDePagamento: any, valorInformado: number): any {
    const valor = this.arredondeValor(Math.max(0, Number(valorInformado || 0)));

    if(this.formaTemDesconto(formaDePagamento)) {
      const desconto = this.calculeDescontoSobreValorPago(formaDePagamento, valor);

      return { valor, taxa: 0, desconto };
    }

    if(this.formaTemTaxa(formaDePagamento)) {
      const cobertura = this.coberturaPorValorInformado(formaDePagamento, valor);
      const taxa = this.arredondeValor(Math.max(0, valor - cobertura));

      return { valor, taxa, desconto: 0 };
    }

    return { valor, taxa: 0, desconto: 0 };
  }

  private coberturaPorValorInformado(formaDePagamento: any, valorInformado: number): number {
    const valor = Math.max(0, Number(valorInformado || 0));

    if(this.formaTemDesconto(formaDePagamento)) {
      const desconto = this.calculeDescontoSobreValorPago(formaDePagamento, valor);

      return this.arredondeValor(valor + desconto);
    }

    if(this.formaTemTaxa(formaDePagamento)) {
      const taxa = formaDePagamento.taxaCobranca;

      if(Number(taxa.percentual || 0) > 0) {
        const fator = 1 + (Number(taxa.percentual || 0) / 100);

        return this.arredondeValor(valor / fator);
      }

      return this.arredondeValor(Math.max(0, valor - Number(taxa.valor || 0)));
    }

    return this.arredondeValor(valor);
  }

  private valorInformadoParaCobertura(formaDePagamento: any, cobertura: number): number {
    const valorCobertura = Math.max(0, Number(cobertura || 0));

    if(this.formaTemDesconto(formaDePagamento)) {
      const percentual = Number(formaDePagamento.desconto || 0);
      const fator = 1 + (percentual / 100);

      if(fator <= 0) return this.arredondeValor(valorCobertura);

      return this.arredondeValor(valorCobertura / fator);
    }

    if(this.formaTemTaxa(formaDePagamento)) {
      const taxa = formaDePagamento.taxaCobranca;

      if(Number(taxa.percentual || 0) > 0)
        return this.arredondeValor(valorCobertura * (1 + (Number(taxa.percentual || 0) / 100)));

      return this.arredondeValor(valorCobertura + Number(taxa.valor || 0));
    }

    return this.arredondeValor(valorCobertura);
  }

  private arredondeValor(valor: number): number {
    return Number(Number(valor || 0).toFixed(2));
  }

  private calculeDescontoSobreValorPago(formaDePagamento: any, valorPago: number): number {
    const percentualDesconto = Number(formaDePagamento?.desconto || 0);

    return this.arredondeValor((Number(valorPago || 0) * percentualDesconto) / 100);
  }

  private apliqueDescontoFormaPagamento(pagamento: any) {
    pagamento.desconto = 0;

    if(!this.formaTemDesconto(pagamento.formaDePagamento)) return;

    pagamento.desconto = this.calculeDescontoSobreValorPago(pagamento.formaDePagamento, pagamento.valor);
    pagamento.valor = this.arredondeValor(Math.max(0, Number(pagamento.valor || 0) - pagamento.desconto));
  }

  private valorDigitadoPagamento(pagamento: any): number {
    if(pagamento.valorInformado != null && pagamento.valorInformado !== '')
      return Number(pagamento.valorInformado || 0);

    return Number(pagamento.trocoPara || pagamento.valor || 0);
  }

  private valorInformadoEstaVazio(valor: any): boolean {
    return valor == null || valor === '';
  }

  private totalPagamentosSem(pagamentoIgnorado: any): number {
    const total = (this.pagamentos || []).reduce((soma, pagamento: any) => {
      if(pagamento === pagamentoIgnorado || pagamento.removido) return soma;
      return soma + this.valorCoberturaPagamento(pagamento);
    }, 0);

    return Number(total.toFixed(2));
  }

  private classifiqueForma(forma: any): string {
    if(forma?.pix)
      return 'pix';

    const texto = this.normalize([
      this.obtenhaMetodoPagamento(forma),
      forma?.nome,
      forma?.descricao,
      forma?.formaDePagamentoPdv?.nome,
      forma?.formaDePagamentoPdv?.tipo,
      forma?.opendeliveryMethod,
      forma?.opendeliveryBrand,
      forma?.formaIntegrada?.descricao,
      forma?.formaIntegrada?.tipoBandeira,
      forma?.bandeira?.nome
    ].filter((item) => item != null && item !== '').join(' '));

    return this.classifiqueTextoPagamento(texto);
  }

  private classifiqueTextoPagamento(texto: string): string {
    const token = this.obtenhaTokenNormalizado(texto);
    const possuiCartao = token.includes('cartao') || token.includes('card');
    const possuiCredito = token.includes('credito') || token.includes('credit');
    const possuiDebito = token.includes('debito') || token.includes('debit');

    if(token.includes('dinheiro') || token.includes('cash')) return 'dinheiro';
    if(token.includes('cartao_credito') || token.includes('cartao_de_credito') ||
      token.includes('credit_card') || (possuiCartao && possuiCredito)) return 'credito';
    if(token.includes('cartao_debito') || token.includes('cartao_de_debito') ||
      token.includes('debit_card') || (possuiCartao && possuiDebito)) return 'debito';
    if(token.includes('pix') || token.includes('qr_code') || token.includes('qrcode')) return 'pix';
    if(token.includes('vale_refeicao') || token.includes('vale_alimentacao') ||
      token.includes('refeicao') || token.includes('alimentacao') || token.includes('vr') ||
      token.includes('alelo') || token.includes('sodexo') || token.includes('ticket_restaurante') ||
      token.includes('food_voucher') || token.includes('meal_voucher') ||
      token.includes('_t_') || token === 't') {
      return 'vale_refeicao';
    }
    if(token.includes('carteira_digital') || token.includes('wallet') || token.includes('digital_wallet')) {
      return 'outros';
    }
    if(token.includes('cartao_presente') || token.includes('voucher') ||
      token.includes('vale') || token.includes('presente') || token.includes('gift')) {
      return 'voucher';
    }

    return 'outros';
  }

  private obtenhaErroPagamentoControle(): string {
    if(this.pixOnlineTunaSelecionado())
      return this.definaErroPagamentoControle('Gere o QR Code Pix antes de fechar a comanda.', 'pix-online');

    if(!this.categoriaSelecionada && !this.existemPagamentosAtivos())
      return this.definaErroPagamentoControle(this.obtenhaMensagemEscolhaCategoria(), 'categoria');

    if(this.categoriaSelecionada && this.exigeEscolhaForma(this.categoriaSelecionada) &&
      !this.formaSelecionadaPertenceCategoriaAtual()) {
      return this.definaErroPagamentoControle(this.obtenhaMensagemEscolhaForma(), 'forma');
    }

    return null;
  }

  private definaErroPagamentoControle(mensagem: string, tipo: string): string {
    this.erroPagamentoControle = mensagem;
    this.tipoErroPagamentoControle = tipo;

    return mensagem;
  }

  private limpeErroPagamentoControle() {
    this.erroPagamentoControle = '';
    this.tipoErroPagamentoControle = '';
  }

  private exigeEscolhaForma(categoria: CategoriaPagamentoComanda): boolean {
    return !!categoria && !!categoria.formas && !!categoria.formas.length &&
      categoria.tipo !== 'dinheiro';
  }

  private existemPagamentosAtivos(): boolean {
    return (this.pagamentos || []).some((pagamento: any) => !pagamento.removido);
  }

  private formaSelecionadaPertenceCategoriaAtual(): boolean {
    if(!this.formaDePagamentoEscolhida?.id || !this.categoriaSelecionada) return false;

    return this.classifiqueForma(this.formaDePagamentoEscolhida) === this.categoriaSelecionada.tipo;
  }

  private tipoCategoriaAtual(): string {
    if(this.tipoCategoriaSelecionada) return this.tipoCategoriaSelecionada;
    if(this.categoriaSelecionada) return this.categoriaSelecionada.tipo;
    if(this.formaDePagamentoEscolhida?.id) return this.classifiqueForma(this.formaDePagamentoEscolhida);

    return null;
  }

  private obtenhaMetodoPagamento(forma: any): string {
    return forma?.formaDePagamentoPdv?.metodo ||
      forma?.metodoPagamento ||
      forma?.metodo ||
      forma?.tipoMetodoPagamento ||
      forma?.tipoDePagamento ||
      null;
  }

  private ehPixOnlineTunaForma(forma: any): boolean {
    return !!(this.pixOnlineTunaForma && forma && forma.id === this.pixOnlineTunaForma.id);
  }

  private normalize(valor: string): string {
    return String(valor || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  private obtenhaTokenNormalizado(valor: string): string {
    return this.normalize(valor)
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }
}
